/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listRenderedWidgets} from '../api'

export const useMutationListRenderedWidgets = createReactQueryMutationHook('listRenderedWidgets', listRenderedWidgets)
